import { useId } from 'react';
import { useFormContext, type FieldError as FieldErrorType } from 'react-hook-form';
import getWithDot from '~/helpers/getWithDot';
import formStyles from '~/styles/form.module.css';
import FieldError from './FieldError';

type Props = {
  label: string;
  labelAffix?: React.ReactNode;
  readonly?: boolean;
  disabled?: boolean;
  required?: boolean;
  registerField: string;
};

export default function Checkbox({
  label,
  labelAffix,
  readonly = false,
  disabled = false,
  registerField,
  required = false,
}: Props) {
  const checkboxId = useId();
  const { register, formState: { errors } } = useFormContext();

  const errorForField = getWithDot<FieldErrorType>(registerField, errors);

  return (
    <>
      <input
        className={formStyles.formCheckbox}
        type="checkbox"
        value="1"
        id={checkboxId}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...register(registerField, { required })}
        disabled={readonly || disabled}
        aria-invalid={errorForField ? 'true' : 'false'}
      />
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label htmlFor={checkboxId}>
        {/* eslint-disable-next-line react/no-danger */}
        <span dangerouslySetInnerHTML={{ __html: label + (required ? '*' : '') }} />
        {labelAffix}
      </label>

      {errorForField && (
        <FieldError error={errorForField} />
      )}
    </>
  );
}
